// Unpublished Work © 2026 Deere & Company.

export interface Links {
    createAccountUrl: string;
}

export const linkStore = {
    createAccountUrl: ''
} as Links;

export function setLinks(links: Links): void {
    Object.assign(linkStore, links);
}
